'use client';
import React, { memo } from 'react';
import Slider from 'react-slick';
import Image from 'next/image';

import { useGetPartnersQuery } from '@/store/api/partner.api';
import { getImageUrl, getQueryString } from '@/utils';

import { partnerSlideSetting } from './config';

import '../../../../styles/slick.css';

const Partner: React.FC = () => {
	const { data } = useGetPartnersQuery(getQueryString({ populate: 'image' }));

	return (
		<div className="overflow-hidden py-6 lg:py-12">
			<Slider {...partnerSlideSetting}>
				{(data?.data || []).map((item: any, idx: number) => (
					<div
						key={idx}
						className="center relative !flex h-[78px] max-w-40"
					>
						<Image
							src={getImageUrl(item?.image).imageUrl}
							blurDataURL={
								getImageUrl(item?.image).imagePlaceholder
							}
							className="object-cover object-center"
							placeholder="blur"
							alt={'DLA Da Nang'}
							width={item?.image?.width / 2}
							height={item?.image?.height / 2}
						/>
					</div>
				))}
			</Slider>
		</div>
	);
};

export default memo(Partner);
